import useTranslation from "@/hooks/useTranslation";
import { NaviPaperSort, NaviParams } from "@/interfaces/navi.interface";
import { setItem } from "@/utils/cookies.util";
import { Select } from "antd";
import React from "react";
import styles from "./styles.module.less";

const { wrapper, flex, label, full } = styles;
const { Option } = Select;

interface IProps {
  sort: NaviPaperSort;
  setSearchParams: (searchParams: Partial<NaviParams>) => void;
}

const Sort: React.FC<IProps> = ({ sort, setSearchParams }) => {
  const onChange = (value: NaviPaperSort) => {
    setSearchParams({ sort: value });
    setItem("navi_sort", value);
  };

  const { t } = useTranslation("explore");

  return (
    <div className={wrapper}>
      <div className={flex}>
        <div className={label}>{t("navi.sidebar.sort.type")}</div>
      </div>
      <Select
        className={full}
        placeholder={t("navi.sidebar.select")}
        value={sort}
        onChange={onChange}
      >
        <Option value={NaviPaperSort.MOST_RELEVANT}>
          {t("navi.sidebar.sort.most-relevant")}
        </Option>
        <Option value={NaviPaperSort.ARTICLE_DATE}>
          {t("navi.sidebar.sort.date")}
        </Option>
        <Option value={NaviPaperSort.IMPACT_FACTOR}>
          {t("navi.sidebar.sort.impact-factor")}
        </Option>
      </Select>
    </div>
  );
};

export default Sort;
